import React, { useState, useEffect } from "react";
import { ReactComponent as Coin } from "../../../assets/svg/coin.svg";
import "./Store.scss";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import PopUpGetAward from "../PopUpGetAward/PopUpGetAward";
import { useTranslation } from "react-i18next";
import PopUpAddress from "../../components/PopUpAddress/PopUpAddress";
import { useAuthValidation } from "../../../hooks/useAuthValidation";
import useStoreItems from "../../../hooks/useStoreItems";

function Store() {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation(); // Obtém os dados do usuário do contexto

  const [awards, setAwards] = useState([]);
  const [address, setAddress] = useState("");
  const [userCoins, setUserCoins] = useState(0);

  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedItemValue, setSelectedItemValue] = useState(null);
  const [selectedItemTitle, setSelectedItemTitle] = useState(null);

  const isModalOpenAddressState = useState(false);
  const [isModalOpenAddress, setIsModalOpenAddress] = isModalOpenAddressState;

  const isModalOpenState = useState(false);
  const [isModalOpen, setIsModalOpen] = isModalOpenState;

  const { items, error } = useStoreItems(user, loading);

  useEffect(() => {
    if (user) {
      setAddress(user?.address?.address || "");
      setUserCoins(Number(user?.rewards?.coins) || 0);
    }
  }, [user]);

  const openModal = (id, title, value) => {
    setIsModalOpen(true);
    setSelectedItemId(id);
    setSelectedItemTitle(title);
    setSelectedItemValue(Number(value) || 0);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedItemId(null);
    setSelectedItemTitle(null);
    setSelectedItemValue(null);
  };

  if (loading) {
    return <div>{t("loading")}</div>;
  }

  if (error) {
    return <div>{t("error-fetching-items")}</div>;
  }

  const normalizedItems = items.map((item) => ({
    ...item,
    value: Number(item.value),
  }));

  const normalizedUserCountry = String(user?.address?.country ?? "")
    .trim()
    .toLowerCase();

  const filteredByCountry = normalizedUserCountry
    ? normalizedItems.filter((item) => {
        const itemCountries = Array.isArray(item.countries)
          ? item.countries
          : String(item.countries ?? "")
              .split(",")
              .map((country) => country.trim())
              .filter(Boolean);

        return itemCountries.some(
          (country) => country.toLowerCase() === normalizedUserCountry
        );
      })
    : normalizedItems;

  return (
    <section className="awards">
      <h2>{t("award-title")}</h2>
      <p>{t("award-text")}</p>
      <Swiper spaceBetween={50} slidesPerView={3} navigation modules={[Navigation, Pagination]}
        breakpoints={{
          0: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}>
        {filteredByCountry.map((award, index) => {
          const awardValue = Number(award.value) || 0;
          const coinsMissing = awardValue - userCoins;
          if (userCoins >= awardValue) {
            return (
              <SwiperSlide className="itens-sliders" key={index}>
                <div className="image-content" style={{ backgroundImage: `url(${award.image.link})` }}>
                  <div className="coins row">
                    <Coin />
                    <span>{awardValue}</span>
                  </div>
                </div>
                <div className="information-content">
                  <p>{award.title}</p>
                  <button onClick={() => openModal(award.id, award.title, awardValue)}>
                    {t("award-available")}
                  </button>
                </div>
              </SwiperSlide>
            );
          } else {
            return (
              <SwiperSlide className="itens-sliders disabled" key={index}>
                <div className="image-content" style={{ backgroundImage: `url(${award.image.link})` }}>
                  <div className="coins row">
                    <Coin />
                    <span>{awardValue}</span>
                  </div>
                </div>
                <div className="information-content">
                  <p>{award.title}</p>
                  <button>
                    <span>
                      {t("award-missing")} <Coin /> {coinsMissing}
                    </span>
                  </button>
                </div>
              </SwiperSlide>
            );
          }
        })}
      </Swiper>
      <Link to="/loja">{t("award-button")}</Link>

      <PopUpGetAward
        isOpen={isModalOpen}
        closeModal={closeModal}
        itemId={selectedItemId}
        itemTitle={selectedItemTitle}
        itemValue={selectedItemValue}
      />
    </section>
  );
}

export default Store;
